const practices = [
  {
    label: 'Architecture & Design',
    items: [
      'Strict adherence to clean architecture principles with clearly defined boundaries between domain logic, data access, and presentation layers',
      'Component-based modular design that enables independent development, testing, and deployment of system parts',
      'Protocol-oriented programming and dependency injection for flexible, testable code structures',
    ],
  },
  {
    label: 'Development Workflow',
    items: [
      'Continuous integration and delivery pipelines that automate builds, testing, and deployment verification',
      'Systematic code review processes that ensure knowledge sharing and consistent quality standards across the team',
      'Iterative development cycles with regular feedback loops to validate technical decisions early and often',
    ],
  },
  {
    label: 'Quality & Reliability',
    items: [
      'Multi-layered testing approach including unit, integration, and end-to-end tests that verify correctness at every level',
      'Proactive monitoring and observability practices that provide visibility into system behavior in production',
      'Structured approach to technical debt management that balances short-term delivery with long-term maintainability',
    ],
  },
];

export default function ApproachSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <div className="w-10 h-px bg-primary-500/60 mx-auto mb-6"></div>
          <p className="text-sm tracking-widest uppercase text-foreground-500 font-label mb-4">
            Engineering Approach
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-light text-foreground-900">
            How We Build Software
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12">
          {practices.map((section) => (
            <div key={section.label}>
              <div className="w-8 h-px bg-secondary-500/50 mb-5"></div>
              <h3 className="text-lg font-heading font-medium text-foreground-900 mb-6">
                {section.label}
              </h3>
              <ul className="space-y-4">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex gap-3 text-sm text-foreground-600 leading-relaxed font-light">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-secondary-400 shrink-0"></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}